/* 🤖 this file was generated by svg-to-ts */
export const matIconLteMobiledata: {
  name: 'lte-mobiledata';
  data: string;
} = {
  name: 'lte-mobiledata',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M6 14h3v2H4V8h2v6zm3-4h2v6h2v-6h2V8H9v2zm12 0V8h-5v8h5v-2h-3v-1h3v-2h-3v-1h3z"/></svg>`
};
